import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SilverZakatTable from "./SilverZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Silver_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Calcul de Zakat sur l'argent 2026 - Calculatrice du seuil de Zakat sur l'argent";
const DESCRIPTION =
  "Calcul de Zakat sur l pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "calcul de zakat sur l, calculatrice calcul de zakat sur l, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/silver-zakat/";
const apiEndpoint = `${SERVER_URL}/${Silver_Zakat_EndPoint}`;
function SilverZakatCalculator() {
  const [yearType, setYearType] = useState("");
  const [gramPriceSilver, setGramPriceSilver] = useState(0);
  const [silverWeight, setSilverWeight] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleSilverWeightChange = (event) => {
    setSilverWeight(event.target.value);
  };
  const handleYearTypeChange = (event) => {
    setYearType(event.target.value);
  };
  const handleGramPriceSilverChange = (event) => {
    setGramPriceSilver(event.target.value);
  };
  const calculateSilverZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ silverWeight, gramPriceSilver, yearType }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}> Calculez la zakat sur l'argent pour tout carat </h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Le calcul de la zakat sur l'argent dépend d'un ensemble de facteurs importants, notamment le poids de l'argent et le prix au gramme. Vous devez également spécifier l'année civile utilisée dans le calcul, soit l'année hijri soit l'année grégorienne.
                </p>
                <p>
                  Le seuil de zakat pour l'argent (nisab) équivaut à 595 grammes. Si le poids d'argent que vous possédez dépasse ce seuil, la zakat sur l'argent devient obligatoire. Le montant de la zakat est calculé en fonction d'un pourcentage spécifié, en utilisant le taux de zakat fitrah de 2,5% selon le calendrier hijri, ou un taux de 2,577% selon le calendrier grégorien, selon l'année civile utilisée.
                </p>
                <p>
                  Après le calcul de la zakat sur l'argent, le montant est ajusté avec précision pour déterminer le montant final due. La calculatrice vous fournira les résultats finaux dans un rapport incluant la valeur de la zakat sur l'argent, l'état de la zakat (obligatoire ou non), le seuil, et le montant financier final.
                </p>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-5 calculatorStyle">
                <div className='p-3 mb-2 bg-success text-white'>
                  Zakat sur l'argent (métal)
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='yearType' >Type d'année</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="yearType"
                      value="gregorian"
                      id="gregorian" checked={yearType === "gregorian"}
                      onChange={handleYearTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="gregorian">
                      Grégorienne
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="yearType"
                      value="hijri"
                      id="hijri" checked={yearType === "hijri"}
                      onChange={handleYearTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="hijri">
                      Hijri
                    </label>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="silverWeightNumber" className="form-label ms-2">Poids total d'argent </label>
                  </b>
                  <input
                    type="number"
                    id="silverWeightNumber"
                    value={silverWeight}
                    onChange={handleSilverWeightChange}
                    className="form-control ml-2"
                    style={{ width: '150px' }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">g</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="gramPriceGoldNumber" className="form-label ms-2">Prix du gramme d'argent (99.9 carats)</label>
                  </b>
                  <input
                    type="number"
                    id="gramPriceGoldNumber"
                    value={gramPriceSilver}
                    onChange={handleGramPriceSilverChange}
                    className="form-control ml-2"
                    style={{ width: '150px' }}
                  />
                </div>
                <br/>
                <hr />
                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                  calculateSilverZakat} disabled={isLoading}>
                  {isLoading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Chargement...</span>
                    </div>
                  ) : (
                    'Calculer'
                  )}
                </button>
              </div>
              <div className="col-sm-12 col-md-7">
                <br />
                {statusCode === 400 && <div className="alert alert-warning"><b><u> Erreur :</u></b> Veuillez remplir tous les champs correctement. </div>}
                {result &&
                  (
                    <div>
                      <h4><div className="p-3 mb-2 bg-success text-white">Résultats: </div></h4>
                      <hr />
                      <SilverZakatTable result={result}></SilverZakatTable>
                    </div>
                  )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col" >
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Description de la calculatrice Zakat sur l'argent</div>
              <div className="info-section-body">
                <h2 style={{ fontSize: '15px' }}>Comment calculer la Zakat sur l'argent</h2>
                <br />
                <p>
                  La calculatrice zakat argent dépend d'un ensemble de variables telles que le poids d'argent et le prix au gramme, en plus du type d'année civile (hijri ou grégorienne). Le seuil de zakat pour l'argent (seuil de zakat) est déterminé, qui est 595 grammes selon les normes religieuses.
                </p>
                <br />
                <p>
                  Si le poids d'argent dépasse le seuil défini, la zakat sur l'argent devient obligatoire. Le montant de la zakat sur l'argent est calculé en utilisant un pourcentage spécifié, qui est 2,5% pour la zakat hijri et 2,577% pour la zakat grégorienne, selon l'année civile.
                </p>
                <br />
                <p>
                  Après le calcul du montant de la zakat sur l'argent, le montant est ajusté correctement pour obtenir la valeur finale de la zakat et le montant financier à payer.
                </p>
                <p>
                  La calculatrice fournit les résultats finaux sous la forme d'un objet contenant le montant de la zakat sur l'argent, l'état de la zakat (obligatoire ou non), le seuil et le montant financier final.
                </p>
                <br />
                <hr />
                <b>Dernière révision :</b> 28/02/2026
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SilverZakatCalculator;
